.wrapper {
  :global {
    .react-datepicker {
      font-family: inherit;
      box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.1);
      border: none;
      border-radius: 8px;
      padding: 8px;
    }
    .react-datepicker__header {
      background: #fff;
      border: none;
    }
    .react-datepicker__navigation--previous,
    .react-datepicker__navigation--next {
      top: 8px;
    }
    .react-datepicker__current-month {
      color: #464646;
      padding-bottom: 8px;
    }
    .react-datepicker__day-name {
      color: #464646;
    }
    .react-datepicker__day--keyboard-selected {
      background-color: inherit;
      color: #9a9a9a;
    }
    .react-datepicker__day--keyboard-selected:hover {
      background-color: #f0f0f0;
    }

    .react-datepicker__day,
    .react-datepicker__day:hover,
    .react-datepicker__day:not([aria-disabled='true']):hover {
      transition: all 0.05s ease;
      color: #9a9a9a;
      font-weight: 400;
      border-radius: 50%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .react-datepicker__day--disabled {
      opacity: 0.2;
      background-color: #fff !important;
      color: #9a9a9a !important;
    }

    .react-datepicker__day--today {
      background-color: var(--chakra-colors-gray-100);
      color: black;
    }
    .react-datepicker__day--today:hover {
      background-color: var(--chakra-colors-gray-200);
      color: black;
    }

    .react-datepicker__day--selected,
    .react-datepicker__day--selected:hover,
    .react-datepicker__day--in-selecting-range:not(
      .react-datepicker__day--in-range
    ),
    .react-datepicker__day--in-selecting-range:not(
        .react-datepicker__day--in-range
      ):hover,
    .react-datepicker__day--in-range,
    .react-datepicker__day--selected:not([aria-disabled='true']):hover,
    .react-datepicker__day--in-range:hover {
      background-color: var(--chakra-colors-brand-500);
      border-radius: 100%;
      color: white;
    }

    .highlighted,
    .highlighted:hover {
      background-color: var(--chakra-colors-brand-500);
      color: white;
      cursor: default;
    }
  }
}

.dark {
  :global {
    .react-datepicker {
      background: #464646;
    }
    .react-datepicker__header {
      background: #464646;
      color: #cccccc;
    }
    .react-datepicker__current-month {
      color: #464646;
    }
    .react-datepicker__day-name {
      color: #cccccc;
    }
    .react-datepicker__day--disabled {
      opacity: 0.2;
      background-color: #464646 !important;
      color: #ccc !important;
    }
  }
}
